import React from 'react';

import { Tooltip } from '@material-ui/core';
import { StyledAvatar } from 'components/avatars';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { WrappedFlexContainer, StyledTypography, GutterCSS } from 'styles/common';

import { SIZES_KEYS_ARRAY } from 'constants/ProjectConstants';
import { getProfileRoute } from 'constants/helper';
import { UserIcon } from 'constants/icons';

export function EmptyNodeView({ onClick, tooltip, ...props }) {
  return (
    <Tooltip title={tooltip}>
      <UserIcon
        style={{ 'border-radius': '50%', 'background-color': 'white' }}
        color="textSecondary"
        onClick={onClick}
        size="tiny"
        {...props}
      />
    </Tooltip>
  );
}

/* 
  a node is an object which contains some score data as well as an employee key which
  has the value of employee object
  supports gutter css
*/
function NodesViewV2({
  nodes,
  employees,
  maxNodes: maxEmployeesToShow = 4,
  avatarSize = 'smaller',
  maxNodesPadding = true,
  history,
  className,
  dontDisplayEmployeeIds = [],
  renderExtraCount,
  useEmployeeClick = true, // whether on employee profilePhoto click, you want to reroute to the profile page
  renderNodesEditView,
  onClick,
  renderEmptyView,
  renderAvatar,
  tooltipPrefix = '',
  leftGutter,
  ...props
}) {
  if (!employees && nodes) {
    employees = nodes.map((node) => node.employee);
  }
  employees = employees.filter((employee) => !dontDisplayEmployeeIds.includes(employee.id));
  const extraEmployeesNumber = employees.length - maxEmployeesToShow;

  function goToProfilePage(id) {
    history.push(getProfileRoute(id));
  }
  const employeesToShow = employees.slice(0, maxEmployeesToShow);
  const moreEmployeeNames = employees
    .slice(maxEmployeesToShow, employees.length)
    .map((employee) => employee.displayName)
    .join(', ');

  return (
    <Container className={`${className} nodesView`} {...props}>
      {employeesToShow.map((employee, i) => (
        <Tooltip key={`MeshNode${i}`} title={tooltipPrefix + employee.displayName}>
          <AvatarContainer>
            {typeof renderAvatar === 'function' ? (
              renderAvatar({
                src: employee.profilePhoto ?? employee.image,
                alt: employee.displayName,
                ownerType: employee.ownerType,
                onClick: (e) => (useEmployeeClick ? goToProfilePage(employee.id) : onClick(e)),
                leftGutter: i === 0 ? 0 : leftGutter,
              })
            ) : (
              <StyledAvatar
                onClick={(e) => (useEmployeeClick ? goToProfilePage(employee.id) : onClick(e))}
                size={avatarSize}
                element
                rightGutter={0.5}
                alt={employee.displayName}
                src={employee.profilePhoto ?? employee.image}
              />
            )}
          </AvatarContainer>
        </Tooltip>
      ))}

      {renderEmptyView && renderEmptyView({ onClick, numberOfEmployeesToShow: employeesToShow.length })}
      {extraEmployeesNumber > 0 && (
        <Tooltip title={moreEmployeeNames} key="1000-MeshNode-ExtraCount">
          {renderExtraCount ? (
            renderExtraCount(extraEmployeesNumber)
          ) : (
            <StyledTypography leftGutter={0.25} variant="caption">
              +{extraEmployeesNumber}
            </StyledTypography>
          )}
        </Tooltip>
      )}
      {renderNodesEditView && renderNodesEditView()}
    </Container>
  );
}

const AvatarContainer = styled.span`
  // margin-right: ${(props) => props.theme.spacing(1)}rem;
  cursor: pointer;
  position: relative;
`;

const Container = styled(WrappedFlexContainer)`
  align-items: center;
  position: relative;
  ${GutterCSS};
`;

NodesViewV2.propTypes = {
  maxNode: PropTypes.number,
  nodes: PropTypes.arrayOf(PropTypes.node),
  avatarSize: PropTypes.oneOf(SIZES_KEYS_ARRAY),
};

export default withRouter(NodesViewV2);
